export const TRANSACTIONREPORT_STATUS_LIST_MUTATION = "TRANSACTIONREPORT_STATUS_LIST_MUTATION";
export const TRANSACTIONREPORT_KEYWORD_LIST_MUTATION = "TRANSACTIONREPORT_KEYWORD_LIST_MUTATION";
